export enum Role {
	ADMINISTRATOR = "Administrator",
	BOOKING_AGENT = "BookingAgent",
	DANGEROUS_GOODS_AGENT = "DangerousGoods",
	QUICK_EDITOR = "QuickEditor",
	VIEW_ONLY = "ViewOnly",
	DRIVER = "Driver",
	COMMUNICATIONS_ONLY = "CommunicationsOnly"
}
